<script setup>
// imports
import {watch} from "vue";
import {computed} from "vue";
import CartArticle from "./CartArticle.vue";
import CartArticleSet from "./CartArticleset.vue";
import CartService from "./CartService.vue";
import {useCartStore} from "../stores/CartStore";
import api from "../api";
import {modalStore} from "../stores/ModalStore";

const cartStore = useCartStore();

const hasLimit = computed(() => {
    return cartStore.totalTax >= 1000
})

// data

// submit
const submitCart = async () => {

    // submit Event-Details
    api.post("/api/events/add", {
        groupedArticles: cartStore.groupedArticles,
        groupedArticleSets: cartStore.groupedArticleSets,
        services: cartStore.services,
    })
        .then(function (response) {
                const eventId = parseInt(response.data.eventId);
                if (!isNaN(parseFloat(eventId)) && isFinite(eventId)) {
                    let role = cartStore.role;
                    // empty local cart
                    cartStore.$reset();
                    // redirect to User->Backend
                    window.location.href = '/' + role + '/events/add/' + eventId;
                } else {
                    console.log('returned not a number');
                }
            }
        )
        .catch(function (error) {
            console.log(error);
        });
}

const addToOrder = async () => {
    // submit Order
    api.post("/api/events/addCartToOrder", {
        orderId: cartStore.auth.activeOrder.id,
        eventId: cartStore.auth.activeOrder.event_id,
        groupedArticles: cartStore.groupedArticles,
        groupedArticleSets: cartStore.groupedArticleSets,
        services: cartStore.services,
    })
        .then(function (response) {
            const eventId = parseInt(response.data.eventId);
            if (!isNaN(parseFloat(eventId)) && isFinite(eventId)) {
                let role = cartStore.role;
                // empty local cart
                cartStore.$reset();
                // redirect to User->Backend
                const eventId = parseInt(response.data.eventId);
                window.location.href = '/' + role + '/events/view/' + eventId;
            } else {
                console.log('returned not a number');
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}
</script>
<template>
    <div
        class="position-relative"
        data-bs-toggle="modal"
        data-bs-target="#cartModal"
        data-bs-backdrop="false"
        @click="cartStore.checkLoginStatus()"
    >
        <!-- Icon that always shows -->
        <svg
            class="bi flex-shrink-0 me-2"
            width="25"
            height="25"
            role="button"
            aria-label="Basket"
        >
            <use xlink:href="#icon-basket"/>
        </svg>
        <span
            v-if="!cartStore.isEmpty"
            class="position-absolute top-1 start-80 translate-middle badge rounded-pill bg-danger"
        >
            {{ cartStore.count }}
            <span class="visually-hidden">Artikel im Warenkorb</span>
        </span>
    </div>

    <Teleport to="body">
        <div
            class="modal fade mb-5"
            id="cartModal"
            aria-hidden="true"
            aria-labelledby="cartModalLabel"
            tabindex="-1"
        >
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="cartModalLabel">

                        </h1>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            @click="modalStore.setIsOpened(false)"
                        ></button>
                    </div>
                    <div class="modal-body mb-5">
                        <div class="accordion" id="frontendAccordion">
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="headingOne">
                                    <button
                                        class="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                        aria-expanded="true"
                                        aria-controls="collapseOne"
                                    >
                                        {{ $t('message.cart') }}
                                    </button>
                                </h2>
                                <div
                                    id="collapseOne"
                                    class="accordion-collapse collapse show"
                                    aria-labelledby="headingOne"
                                    data-bs-parent="#frontendAccordion"
                                >
                                    <div class="accordion-body">
                                        <div v-if="!cartStore.noArticles">
                                            <div class="table-responsive">
                                                <table class="table">
                                                    <thead>
                                                    <tr>
                                                        <th class="w-250px">
                                                            {{ $t('message.article') }}
                                                        </th>
                                                        <th></th>
                                                        <th
                                                            class="w-200px text-end"
                                                        >
                                                            {{ $t('message.price') }}
                                                        </th>
                                                        <th
                                                            class="w-250px text-center"
                                                        >
                                                            Anzahl
                                                        </th>
                                                        <th class="text-end">
                                                            Total CHF
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-if="cartStore.countArticleSets > 0">
                                                        <td colspan="5">
                                                            <h3 class="mb-0">Settings</h3>
                                                        </td>
                                                    </tr>
                                                    <CartArticleSet
                                                        v-if="cartStore.countArticleSets > 0"
                                                        v-for="(articleSets, slug) in cartStore.groupedArticleSets"
                                                        :key="slug"
                                                        :product="articleSets[0]"
                                                        :rentfactor="120"
                                                        :count="cartStore.groupArticleSetCount(slug)"
                                                        @updateCount="cartStore.setArticleSetCount(articleSets[0],$event)"
                                                        @clear="cartStore.clearArticleSet(slug)"
                                                    />
                                                    <tr v-if="cartStore.countArticles > 0">
                                                        <td colspan="5">
                                                            <h3 class="mb-0">Mobiliar</h3>
                                                        </td>
                                                    </tr>
                                                    <CartArticle
                                                        v-if="cartStore.countArticles > 0"
                                                        v-for="(articles, slug) in cartStore.groupedArticles"
                                                        :key="slug"
                                                        :product="articles[0]"
                                                        :count="cartStore.groupArticleCount(slug)"
                                                        @updateCount="cartStore.setArticleCount(articles[0],$event)"
                                                        @clear="cartStore.clearArticle(slug)"
                                                    />
                                                    </tbody>
                                                    <tfoot>
                                                    <tr>
                                                        <td colspan="3"></td>
                                                        <td>Total Kosten (exkl. MwSt)</td>
                                                        <td class="text-end">
                                                            {{
                                                                cartStore.total?.toLocaleString("de-CH", {
                                                                    style: 'currency',
                                                                    currency: 'CHF'
                                                                })
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="(cartStore.total > cartStore.totalDiscount)">
                                                        <td colspan="3"></td>
                                                        <td><span class="discount-red">Rabatt:</span></td>
                                                        <td class="text-end">
                                                        <span class="discount-red">
                                                        - {{
                                                                (cartStore.total - cartStore.totalDiscount)?.toLocaleString("de-CH", {
                                                                    style: 'currency',
                                                                    currency: 'CHF'
                                                                })
                                                            }}
                                                        </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"></td>
                                                        <td>zzgl. 8.1% MwSt</td>
                                                        <td class="text-end">
                                                            {{
                                                                cartStore.tax?.toLocaleString("de-CH", {
                                                                    style: 'currency',
                                                                    currency: 'CHF'
                                                                })
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"></td>
                                                        <td>Total</td>
                                                        <td class="text-end">
                                                            {{
                                                                cartStore.totalTax?.toLocaleString("de-CH", {
                                                                    style: 'currency',
                                                                    currency: 'CHF'
                                                                })
                                                            }}
                                                        </td>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                            <div>
                                                <p>
                                                    Die Mietpreise über die gesamte Ausleihdauer werden nach Erfassen
                                                    des Veranstaltungsdatums und dessen Auf- und Abbauzeit berechnet und
                                                    Ihnen unverbindlich per E-Mail zugestellt.<br>
                                                    Sie benötigen die Artikel mehr als 10 Tage? Wir erstellen Ihnen
                                                    gerne ein individuelles Angebot.<br>
                                                    Die Mietpreise beziehen sich auf eine Ausleihfrist von 3 Tagen inkl.
                                                    2 Tagen Handling, bei längerer Mietdauer ergibt sich der Preis über
                                                    den angegebenen Mietfaktor.
                                                </p>
                                            </div>
                                        </div>
                                        <div v-if="!cartStore.noServices">
                                            <h3 class="mb-0">Services</h3>
                                            <div class="table-responsive">
                                                <table class="table">
                                                    <thead>
                                                    <tr>
                                                        <th class="w-250px">
                                                            Service
                                                        </th>
                                                        <th
                                                            class="text-end"
                                                        >
                                                            {{ $t('message.price') }}
                                                        </th>
                                                        <th
                                                            class="w-200px text-end"
                                                        >
                                                        </th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <CartService
                                                        v-if="cartStore.countServices > 0"
                                                        v-for="(service, slug) in cartStore.services"
                                                        :key="slug"
                                                        :service="service"
                                                        @clear="cartStore.clearService(service.slug)"
                                                    />
                                                    </tbody>
                                                </table>
                                            </div>
                                            <p>
                                                Die Kosten der Services werden nach einem Beratungsgespräch
                                                ermittelt.
                                            </p>
                                        </div>
                                        <div v-else class="alert alert-primary mt-3" role="alert">
                                            Benötigen Sie "Add Services", kreative Lösungen, Planungen, CAD-Pläne oder
                                            Produktionen? <a href="/add-services">Klicken Sie hier</a>.
                                        </div>
                                        <div
                                            v-if="cartStore.auth?.authenticated && !cartStore.isEmpty">
                                            <button
                                                class="btn btn-success ms-auto"
                                                :class="{disabled: !hasLimit || cartStore.role === 'admin'}"
                                                type="button"
                                                @click="submitCart"
                                            >
                                                mit unverbindlicher Anfrage fortfahren
                                            </button>
                                            <div v-if="cartStore.auth.activeOrder?.id" class="d-inline-block">
                                                <div class="d-inline-block ps-3 pe-3">- oder -</div>
                                                <button
                                                    class="btn btn-success ms-auto"
                                                    type="button"
                                                    @click="addToOrder"
                                                >
                                                    zur bestehenden Bestellung hinzufügen
                                                </button>
                                            </div>
                                        </div>
                                        <p v-else-if="!cartStore.auth?.authenticated" class="alert alert-info">
                                            Bitte <a href="/login">melden Sie sich an</a> oder <a
                                            href="/registrierung">registrieren</a>
                                            Sie sich, um mit der Bestellung fortzufahren.
                                        </p>
                                        <div v-if="cartStore.isEmpty">
                                            <p>
                                                <em>Der Warenkorb ist leer</em>
                                            </p>
                                        </div>
                                        <div class="alert alert-primary mt-3" role="alert" v-if="!hasLimit">
                                            Diese Plattform ist für mittelgrosse und grosse Anlässe ausgelegt
                                            und deshalb auch kosteneffizient. Leider ist es uns nicht möglich
                                            kleine Aufträge auszuführen. Die Logistik und Planungskosten wären
                                            im Verhältnis zum Auftrag viel zu gross. Darum haben wir eine Limite
                                            von 1000.- CHF festgelegt.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>
<style scoped>

</style>
